module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col customer\">\n      Berater für {{name}}\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auswertung/auswertung.component.html
// module id = ./src/app/auswertung/auswertung.component.html
// module chunks = main